var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "76",
        height: "138",
        viewBox: "0 0 76 138",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M38 0L0 52.2502H26.1249V80.7502H49.875V52.2502H76L38 0Z",
          fill: "#4FBA6F",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M45.1251 90.2501H30.875C28.2626 90.2501 26.125 92.3877 26.125 95.0001C26.125 97.6125 28.2626 99.7501 30.875 99.7501H45.1251C47.7375 99.7501 49.8751 97.6125 49.8751 95.0001C49.8751 92.3877 47.7375 90.2501 45.1251 90.2501Z",
          fill: "#4FBA6F",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M45.1251 109.25H30.875C28.2626 109.25 26.125 111.388 26.125 114C26.125 116.613 28.2626 118.75 30.875 118.75H45.1251C47.7375 118.75 49.8751 116.613 49.8751 114C49.8751 111.388 47.7375 109.25 45.1251 109.25Z",
          fill: "#4FBA6F",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M45.1251 128.25H30.875C28.2626 128.25 26.125 130.388 26.125 133C26.125 135.613 28.2626 137.75 30.875 137.75H45.1251C47.7375 137.75 49.8751 135.613 49.8751 133C49.8751 130.388 47.7375 128.25 45.1251 128.25Z",
          fill: "#4FBA6F",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }